import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import r from "../../core/Logger.js";
import { debounce as s, ignoreAbortErrors as t } from "../../core/promiseUtils.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import { registerLayer as i, unregisterLayer as h } from "./refresh.js";

function p(e) {
  return e && "object" == typeof e && "refreshTimestamp" in e && "refresh" in e;
}

var n = function n(p) {
  var n = /*#__PURE__*/function (_p) {
    _inherits(n, _p);

    var _super = _createSuper(n);

    function n() {
      var _this;

      _classCallCheck(this, n);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(e)), _this.refreshInterval = 0, _this.refreshTimestamp = 0, _this._debounceHasDataChanged = s(function () {
        return _this.hasDataChanged();
      }), _this.when().then(function () {
        i(_assertThisInitialized(_this));
      }, function () {});
      return _this;
    }

    _createClass(n, [{
      key: "destroy",
      value: function destroy() {
        h(this);
      }
    }, {
      key: "refreshParameters",
      get: function get() {
        return {
          _ts: this.refreshTimestamp || null
        };
      }
    }, {
      key: "refresh",
      value: function refresh() {
        var _this2 = this;

        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
        t(this._debounceHasDataChanged()).then(function (r) {
          r && _this2._set("refreshTimestamp", e), _this2.emit("refresh", {
            dataChanged: r
          });
        }, function (e) {
          r.getLogger(_this2.declaredClass).error(e), _this2.emit("refresh", {
            dataChanged: !1,
            error: e
          });
        });
      }
    }, {
      key: "hasDataChanged",
      value: function () {
        var _hasDataChanged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", !0);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function hasDataChanged() {
          return _hasDataChanged.apply(this, arguments);
        }

        return hasDataChanged;
      }()
    }]);

    return n;
  }(p);

  return e([o({
    type: Number,
    cast: function cast(e) {
      return e >= .1 ? e : e <= 0 ? 0 : .1;
    },
    json: {
      write: !0
    }
  })], n.prototype, "refreshInterval", void 0), e([o({
    readOnly: !0
  })], n.prototype, "refreshTimestamp", void 0), e([o()], n.prototype, "refreshParameters", null), n = e([a("esri.layers.mixins.RefreshableLayer")], n), n;
};

export { n as RefreshableLayer, p as isRefreshableLayer };